var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterRedesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1DA1F2",
  fillRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M17.473 10.286c-1.457 0-2.638 1.153-2.638 2.575q0 .304.068.587a7.55 7.55 0 0 1-5.437-2.69c-.227.38-.357.822-.357 1.294 0 .893.466 1.682 1.174 2.144a2.7 2.7 0 0 1-1.195-.322v.032c0 1.248.91 2.289 2.116 2.525a2.7 2.7 0 0 1-1.191.044 2.63 2.63 0 0 0 2.464 1.79A5.38 5.38 0 0 1 9.2 19.366a6 6 0 0 1-.63-.036 7.6 7.6 0 0 0 4.044 1.157c4.852 0 7.505-3.925 7.505-7.328q0-.168-.008-.333a5.3 5.3 0 0 0 1.317-1.334 5.4 5.4 0 0 1-1.515.406 2.6 2.6 0 0 0 1.16-1.425 5.4 5.4 0 0 1-1.676.625 2.66 2.66 0 0 0-1.925-.813",
  clipRule: "evenodd"
})));
export default SvgTwitterRedesign;